// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let ArticleAnchors = class ArticleAnchors extends Vue {
    goTo(slug) {
        const element = document.getElementById(slug);
        if (!element) {
            return;
        }
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
__decorate([
    Prop({ type: Array, required: true })
], ArticleAnchors.prototype, "anchors", void 0);
ArticleAnchors = __decorate([
    Component({
        name: 'ArticleAnchors',
        template: `
    <div class="article-header__anchors">
      <a v-for="anchor in anchors" class="article-header__anchors__item" :href="'#'+ anchor.slug" @click.prevent="goTo(anchor.slug)">
        {{anchor.label}}

        <i class="article-header__anchors__item__icon icon-arrow-top-right" />
      </a>
    </div>
  `
    })
], ArticleAnchors);
export { ArticleAnchors };
